module.exports = __webpack_public_path__ + "static/media/translate-green.2d435fc5.svg";